<mds-report-sidepanel-view
  [reportIcon]="reportData.reportIcon"
  [reportSubTitle]="reportData.reportSubTitle"
  [reportName]="reportData.reportDataPanelTitle"
  [chips]="reportData.chips"
  [reportDataPanelTitle]="reportData.reportDataPanelTitle"
  [resultPanelTitle]="reportData.resultPanelTitle"
  [showResultPanel]="!!reportUrl"
  [infoIcon]="reportData.infoIcon"
  [infoIconTooltip]="reportInfo"
  [panelCloseIcon]="reportData.panelCloseIcon"
  (toggleSidePanel)="onToggleSidePanel()"
>
  <div class="form-schema-container" formSchemaSection>
    <ul>
      <li>
        @if (schema && schema.formSchema) {
          <div class="accordion-inner-container">
            @if (loading) {
              <div class="disable-user-input"></div>
            }
            <div
              class="form-schema"
              mdsInlineFormSchema
              [schema]="schema"
              [lines]="lines"
              (openMenuItem)="openMenuItem($event)"
              (formValueChanged)="formValueChanged($event)"
            ></div>
            @if (rid != 'background') {
              <mds-button
                (click)="createReport()"
                aria-label="Create Report"
                [icon]="createReportIcon"
                [isIconLeft]="true"
                [disabled]="!formValues?.valid || !formValues?.valid || loading"
              >
                Create
              </mds-button>
            }
            @if (rid == 'background') {
              <mds-button
                (click)="reCalculateReport()"
                aria-label="Recalculate Report"
                [icon]="createReportIcon"
                [isIconLeft]="true"
              >
                Re-calculate
              </mds-button>
            }
          </div>
        }
      </li>
    </ul>
  </div>
  @if (reportUrl) {
    <div resultUrlSection>
      <div class="copy-clip-board accordion-inner-container">
        <input
          type="text"
          class="copy-input"
          aria-label="copy MSBI link"
          [value]="reportUrl"
          #msbi
          (click)="copyMSBI(msbi)"
          readonly="readonly"
        />
        <mds-button
          type="secondary"
          (click)="copyMSBI(msbi)"
          aria-label="copy MSBI link"
          [icon]="copyButtonIcon"
          [isIconLeft]="true"
        >
          Copy API link
        </mds-button>
        <mds-alert
          type="info"
          text="Use it to import into Power BI or your preferred tool."
        ></mds-alert>
      </div>
    </div>
  }
</mds-report-sidepanel-view>
